import { eCrossSellLink } from '../../utils/enums';

export default {
  [eCrossSellLink.poker] : [54, 116, 110, 115, 117, 131, 128],
  [eCrossSellLink.casino] : [112, 54, 8, 116, 110, 115, 117, 131, 128]
};
